export class CommonConstants {
  public static toolbarItems: string[] = [
    'save',
    '|',
    'heading',
    '|',
    'subtemplates',
    'hidedataignoreattribute',
    'bold',
    'italic',
    'underline',
    'strikethrough',
    'subscript',
    'superscript',
    'smallcaps',
    'removeFormat',
    '|',
    'insertreference',
    'reorderreferences',
    'alignment',
    '|',
    'bulletedList',
    'numberedList',
    '|',
    'indent',
    'outdent',
    '|',
    'insertLink',
    'blockQuote',
    'insertTable',
    'insertmedia',
    '|',
    'undo',
    'redo',
    'cut',
    'findandreplace',
    '|',
    'selectAll',
    'specialCharacters',
    '|',
    'comment',
    'wproofreader',
    'trackchanges',
    'sourceEditingEnhanced',
    'releasenotes',
    'aiAssistant',
    'showAICommands',
  ];

  public static attributeToRemove: string[] = [
    'listIndent',
    'listItemId',
    'listType',
    'listStyle',
  ];
  public static headings: string[] = [
    'heading1',
    'heading2',
    'heading3',
    'heading4',
    'heading5',
    'heading6',
  ];
  public static pciCoreLinks = 'pcicore:linksTo';
  public static SKOS_EDITORIAL_NOTE = 'skos:editorialNote';
  public static REL = 'rel';

  public static dataParentCitation = 'data-parentcitation';
  public static dataCitationCount = 'data-citationcount';
  public static dataReleaseNotes = 'data-releasenotes';
  public static numberedCitation = 'numbered-citation';
  public static NUMBERED_CITATION = 'numberedcitation';
  public static dataUnlock = 'data-unlock';
  public static INSERT = 'insert';
  public static REMOVE = 'remove';
  public static readonly trackchangesMarkup = {
    SUGGESTION: 'data-suggestion',
    SUGGESTION_END_AFTER: 'data-suggestion-end-after',
    SUGGESTION_END_BEFORE: 'data-suggestion-end-before',
    SUGGESTION_START_AFTER: 'data-suggestion-start-after',
    SUGGESTION_START_BEFORE: 'data-suggestion-start-before',
    SUGGESTION_DELETION: 'suggestion:deletion',
    NAME: 'name',
  };
  public static readonly commentsMarkup = [
    'data-comment-end-after',
    'data-comment-end-before',
    'data-comment-start-after',
    'data-comment-start-before',
  ];
  public static readonly commentEvents = {
    ADD_COMMENT: 'addComment',
    UPDATE_COMMENT: 'updateComment',
    REMOVE_COMMENT: 'removeComment',
    REMOVE_COMMENT_THREAD: 'removeCommentThread',
    DRAG_START: 'dragstart',
  };
  public static readonly extensionsList = {
    image: ['png', 'jpg', 'jpeg', 'gif', 'bpm', 'svg'],
    media: ['wav', 'mp4', 'mp3', 'webm', 'ogg'],
    text: ['txt', 'json', 'ts', 'css', 'md'],
  };
  public static readonly mimeTypesList = {
    text: ['text/plain', 'text/csv', 'application/x-javascript'],
    xml: ['text/xml'],
    pdf: ['application/pdf'],
    image: [
      'image/png',
      'image/jpeg',
      'image/gif',
      'image/bmp',
      'image/svg+xml',
    ],
    media: [
      'video/mp4',
      'video/webm',
      'video/ogg',
      'audio/mpeg',
      'audio/mp3',
      'audio/ogg',
      'audio/wav',
    ],
  };

  public static readonly htmlXmlExtensions = [
    'html',
    'htm',
    'xhtml',
    'xml',
    'xsl',
    'xslt',
    'svg',
    'rss',
    'atom',
    'opf',
  ];

  public static readonly htmlXmlMimeTypes = [
    ...CommonConstants.mimeTypesList.xml,
    'text/html',
    'application/xhtml+xml',
  ];

  public static workingCopyAspect = 'cm:workingcopy';
  public static workingCopyProperty = 'cm:workingCopyOwner';
  public static lockProperty = 'cm:lockType';
  public static lockableAspectName = 'cm:lockable';
  public static readLock = 'READ_ONLY_LOCK';
  public static writeLock = 'WRITE_LOCK';
  public static ckEditorMainClassName = '.ck-editor__main';
  public static ckEditorEditablePlaceholder = '.ck-editor__editable';
  public static parentCitationPlaceholder = 'data-parentcitation';
  public static dataCommentId = 'data-comment';
  public static SPAN = 'SPAN';
  public static dataSuggestionId = 'data-suggestion';
  public static ckeditorWrapperPlaceholder = 'ckeditor-wrapper';
  public static dataCommentClass = 'ck-comment-marker';
  public static dataSuggestionClass = 'ck-suggestion-marker';
  public static dataCommentActiveClass = 'ck-comment-marker--active';
  public static dataSuggestionActiveClass = 'ck-suggestion-marker--active';
  public static dataResolvedCommentClass = 'ck-resolved-comment';
  public static CK_THREAD_CLASS = '.ck-thread';
  public static CK_THREAD_ACTIVE = 'ck-thread--active';
  public static dataCitationCountPlaceholder = 'data-citationcount';
  public static typeOfAttribute = 'typeof';
  public static dataCitationAttribute = 'data-citationattribute';
  public static wkKeyword = 'wk-keyword-ref';
  public static dataSuggestionDeletion = 'ck-suggestion-marker-deletion';
  public static dataSuggestionInsertion = 'ck-suggestion-marker-insertion';
  public static INSERTION = 'insertion';
  public static DELETION = 'deletion';
  public static comments = {
    ckAnnotationWrapper: 'ck-annotation-wrapper',
    ckCommentWrapper: 'ck-comment__wrapper',
    ckSidebarItem: 'ck-sidebar-item',
    ckThreadContainer: 'ck-thread__container',
    dataThreadId: 'data-thread-id',
    dataCommentThreadId: 'data-comment-thread-id',
    dataComment: 'data-comment',
    wideSidebar: 'wideSidebar',
  };
  public static trackChanges = {
    acceptAllSuggestions: 'Accept all changes',
    rejectAllSuggestions: 'Reject all changes',
    ckSuggestionWrapper: 'ck-suggestion-wrapper',
    ckSuggestionWrapperActive: 'ck-suggestion-wrapper--active',
  };
  public static readonly trackChangesVisibility = {
    hideAll: 'wk-hide-track-changes-all',
    hideInsertions: 'wk-hide-track-changes-insertions',
    hideDeletions: 'wk-hide-track-changes-deletions',
    hideFormatting: 'wk-hide-track-changes-formatting',
  };
  public static prefLabel = 'skos:prefLabel';
  public static propertyAttribute = 'property';
  public static DCTERMS_TITLE = 'dcterms:title';
  public static pciCoreWebResource = 'pcicore:WebResource';
  public static pciCoreBibliographicResource = 'pcicore:BibliographicResource';
  public static pciCoreMediaResource = 'pcicore:MediaResource';
  public static isCitationValid = 'apollo:isCitationValid';
  public static rightClickOptions = {
    goToLink: 'Go To Link',
    editLink: 'Edit Link',
    deleteLink: 'Delete Link',
    LINK_TO: 'Link To...',
  };
  public static miniEditorPlugins = {
    toolbar: {
      items: [
        'bold',
        'italic',
        'underline',
        'strikethrough',
        'subscript',
        'superscript',
        'smallcaps',
        'removeFormat',
        '|',
        'specialCharacters',
        'insertLink',
        '|',
        'cut',
      ],
    },
    type: 'mini-editor',
    placeholder: 'Add a numbered or unnumbered reference to the document.',
  };
  public static stickyPanelContentClass = 'ck-sticky-panel__content';
  public static editorEditableInline = 'ck-editor__editable_inline';
  public static applicationText = 'application|text';
  public static commentStart = 'comment-start';
  public static suggestionStart = 'suggestion-start';
  public static nameAttr = 'name';
  public static ID_ATTR = 'id';
  public static SUGGESTION_VALUE = 'suggestion';
  public static DATA_NOONE = 'data-noone';
  public static ELEMENT_START = 'elementStart';
  public static ELEMENT_END = 'elementEnd';
  public static readonly splitSpan = '*Split:* span';
  public static readonly splitList = '*Split:* list item';
  public static readonly splitPara = '*Split:* paragraph';
  public static readonly comment = 'comment';
  public static readonly ROUTER_ON_SAME_URL_RELOAD = 'reload';
  public static readonly dataSuggestionIdAttribute = 'data-suggestion-id';
  public static inlineMediaClass = 'ck-span';
  public static customTextAttributes = [
    'underline',
    'superscript',
    'subscript',
    'bold',
    'smallcaps',
    'strikethrough',
    'italic',
    'linkhref',
  ];
  public static removeSubtemplate = 'Remove Subtemplate';
  public static processId = 'apollo:processId';
  public static stepAssignedUser = 'apollo:stepAssignedUser';
  public static stepId = 'apollo:stepId';
  public static CK_PLUGINS = {
    TRACK_CHANGES: 'TrackChanges',
    TRACK_CHANGES_EDITING: 'TrackChangesEditing',
    CMD_TRACK_CHANGES: 'trackChanges',
    DISCARD_SUGGESTION: 'discardSuggestion',
    DISCARDALL_SUGGESTION: 'discardAllSuggestions',
    ACCEPTALL_SUGGESTION: 'acceptAllSuggestions',
    ACCEPT_SUGGESTION: 'acceptSuggestion',
    RHP_TRACK_CHANGES: 'rhpTrackChanges',
    CMD_UPDATE_PLACEHOLDER: 'updateplaceholder',
    INSERT_CROSS_REFERENCE: 'insertreference',
    INSERT_LINK: 'insertlink',
    DELETE_KEYWORD: 'keyworddefinitiondelete',
    SELECT_ALL: 'selectAll',
    ANNOTATION_UIS: 'AnnotationsUIs',
    ANNOTATIONS: 'Annotations',
    COMMENTS_REPOSITORY: 'CommentsRepository',
    CONTEXTUAL_BALLOON: 'ContextualBalloon',
    EDIT_SOURCE_LABEL: 'Source',
  };
  public static linkIconClassInMainEditor =
    '.adf-viewer-layout-content .insertLinkIcon';

  //Attributes
  public static listStyle = 'listStyle';
  public static listType = 'listType';
  public static rel = 'rel';
  public static RELEASE_NOTES_CLASS = 'ref releasenotes';
  public static REF_CLASS = 'ref';

  //Tagnames
  public static spanTagName = 'span';
  public static paragraphTagName = 'paragraph';
  public static divTagName = 'div';
  public static headerTagName = 'header';
  public static resourceAttrName = 'resource';
  public static html = 'html';
  public static attributes = 'attributes';
  public static RELEASE_NOTES_TAG_NAME = 'releasenotes';
  public static TABLE_TAG_NAME = 'table';
  public static CAPTION_TAG_NAME = 'caption';

  public static dataSubtemplateName = 'data-subtemplate-name';
  public static dataSubtemplateAllow = 'data-subtemplates-allow';

  public static insertCrossLinkIcon = '.insertCrossLinkIcon';
  public static insertCrossRefOptionsId = {
    NUMBERED_REFERENCES: 'numreferences',
    UNNUMBERED_REFERENCES: 'unnumreferences',
    KEYWORD_DEFINITION: 'keywords',
  };
  public static editor = {
    EDITOR: 'editor',
    MINI_EDITOR: 'minieditor',
    DEFINITION_EDITOR: 'definitioneditor',
    RIGHT_HAND_EDITOR: 'rightHandEditor',
  };

  public static GET_ATTRIBUTE_NOT_ALLOW_FOR_KEYWORD = (): string[] => [
    `rel="${CommonConstants.pciCoreLinks}"`,
    `typeof="${CommonConstants.pciCoreWebResource}"`,
    `typeof="${CommonConstants.pciCoreBibliographicResource}"`,
    `typeof="${CommonConstants.pciCoreMediaResource}"`,
    `class="${CommonConstants.wkKeyword}"`,
  ];
  public static BASE_HREF_FOR_KEYWORD = 'baseHrefForKeyword';
  public static CONTEXT_MENU = 'contextmenu';
  public static LINK_PLUGIN_CMD = 'insertlink';
  public static INSERT_TEXT_CMD = 'insertText';

  //Do not add or remove anything from this object(&NoBreak; spaces)
  public static EMPTY_SPACE = {
    NO_BREAK_SPACE: ' ⁠⁠⁠⁠⁠⁠⁠',
    NO_BREAK: '⁠⁠⁠⁠⁠⁠⁠',
  };
  public static commands = {
    ADD_COMMENT_THREAD: 'addCommentThread',
    REMOVE_COMMENT_THREAD: 'removeCommentThread',
    UPDATE_COMMENT: 'updateComment',
  };
  public static WIDGET_SELECTED = 'ck-widget_selected';
  public static EDITOR_INSTANCE = 'editor-instance';
  public static TOOLBAR_ITEMS = 'ck-toolbar__items';
  public static DATA_SOURCE_ID = 'data-source-id';
  public static DATA_CKE_TOOLTIP_TEXT = 'data-cke-tooltip-text';
  public static DATA_CKE_TOOLTIP_POSITION = 'data-cke-tooltip-position';
  public static DATA_CKE_TOOLTIP_CLASS = 'data-cke-tooltip-class';
  public static DATA_FRAGMENT_ATTRIBUTE = 'data-fragment';
  public static DATA_RESOURCE_ATTRIBUTE = 'resource';
  public static FRAGMENT_TARGET_TOOLTIP =
    'This text is linked with another text fragment in the document. Deleting it will lead to orphaned links in the document.';
  public static FRAGMENT_TARGET_TOOLTIP_CLASS = 'internalLinkWarning';
  public static SELECTED_CHILD = 'selected-child';
  public static SELECTED_ELEMENT = 'selected-element';
  public static BOX_COMMENTS = 'box-comments';
  public static TABLE_ELEMENTS = {
    TABLE: 'table',
    TABLE_CELL: 'tableCell',
    TABLE_ROW: 'tableRow',
    TABLE_COLUMN: 'tableColumn',
    TABLE_UTILS: 'TableUtils',
  };
  public static CONTENT_EDITABLE = 'contenteditable';
  public static NONEDITABLESUBTEMPLATE = 'nonEditableSubtemplate';
  public static EDITABLESUBTEMPLATE = 'editableSubtemplate';
  public static EVENTS = {
    CUT: 'cut',
    DELETE_EVENT: 'delete',
    CLIPBOARD_OUTPUT: 'clipboardOutput',
  };
  public static REJECT_ALL_SUGGESTIONS_CLASS = 'rejectAllSuggestions';
  public static ACCEPT_ALL_SUGGESTIONS_CLASS = 'acceptAllSuggestions';
  public static RENUMBER_CITATIONS_PLUGIN_NAME = 'renumbercitations';
  public static TOGGLE_TRACKCHANGES_VIEW = {
    INLINE: 'inline',
    SIDEBAR: 'sidebar',
  };
  public static USER_PREFERENCE_FOR_INLINE_TOGGLE =
    'userPreferenceForInlineToggle';
  public static ENABLE_INLINE_TRACK_CHANGES = 'enableInlineTrackChanges';
  public static VALIDATION_STATUS = {
    IN_PROGRESS: 'IN_PROGRESS',
    INVALID: 'INVALID',
    NOT_VALIDATED: 'NOT_VALIDATED',
    VALID: 'VALID',
    PROCESSING_FAILED: 'PROCESSING_FAILED',
  };

  public static APOLLO_TENANT_ID = 'apollo:tenantId';
  public static EXPY = {
    EVENTS: {
      CHAT_SOURCE_CLICKED: 'ChatSourceClicked' as const,
    },
    FILTER: {
      COMPLEX: 'Complex' as const,
      PREFIX: 'Prefix' as const,
      FIELD_NAME: 'tenantid.keyword' as const,
      OPERATORS: {
        OR: 'OR' as const,
      },
    },
  };
  public static PROCESS_COMPLETED = 'Process completed';
  public static PROCESS_CANCELLED = 'Process cancelled';
  public static CANCEL_PROCESS_DOCUMENT_HAS_WORKING_COPY =
    'APP.MESSAGES.ERRORS.CANCEL_PROCESS.DOCUMENT_HAS_WORKING_COPY';
  public static CM_TITLE = 'cm:title';
  public static GENERIC_CITATION_QUERYSELECTOR =
    '.ref[typeof="pcicore:BibliographicResource"][rel="pcicore:linksTo"]';
  public static NUMBERED_CITATION_QUERYSELECTOR =
    'span[typeof="pcicore:BibliographicResource"][rel="pcicore:linksTo"][class~="ref"][class~="numbered-citation"]';
  public static CONTEXT_MENU_ITEMS_FOR_BULLETS = {
    cut: 'Cut Bullet List',
    copy: 'Copy Bullet List',
  };
  public static CONFIRM_CANCEL_CHECKOUT = {
    key: 'confirmCancelCheckout',
    title: 'APP.MESSAGES.CONFIRM_CANCEL_CHECKOUT.TITLE',
    message: 'APP.MESSAGES.CONFIRM_CANCEL_CHECKOUT.DESCRIPTION',
    yesLabel: 'APP.COMMON.CONFIRM',
    noLabel: 'APP.COMMON.CANCEL',
    ignoreUnlistener: true,
  };
  public static TEXT_FORMATTING_PLUGINS = [
    'bold',
    'italic',
    'underline',
    'subscript',
    'superscript',
    'strikethrough',
    'smallcaps',
  ];
}
